/**
 * Bulk edit of rule templates. Gather a couple of actions {@link AbstractRuleTemplateAction},
 * and sort them into different list so that they can be processed
 * in a bulk.
 */
export default class BulkRuleTemplateAction {
	constructor() {
		this._ruleTemplatesToAdd = [];
		this._ruleTemplatesToUpdate = [];
		this._ruleTemplatesToRemove = [];
	}

	perform(fn) {
		fn(this);
	}

	appendActions(actions) {
		actions.forEach((action) => {
			action.appendTo(this);
		});
	}

	appendAddRuleAction({ ruleTemplate }) {
		this._ruleTemplatesToAdd.push(ruleTemplate);
	}

	appendUpdateRuleAction({ ruleTemplate }) {
		this._ruleTemplatesToUpdate.push(ruleTemplate);
	}

	appendRemoveRuleAction({ ruleTemplate }) {
		this._ruleTemplatesToRemove.push(ruleTemplate);
	}

	getRuleTemplatesToAdd() {
		return this._ruleTemplatesToAdd;
	}

	getRuleTemplatesToUpdate() {
		return this._ruleTemplatesToUpdate;
	}

	getRuleTemplatesToRemove() {
		return this._ruleTemplatesToRemove;
	}
}
